import { useEffect, useState } from "react";

const useOnboarding = (hasSeenTour) => {
  const [run, setRun] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(hasSeenTour)) {
      setRun(true);
    }
  }, []);

  const handleCallback = ({ status }) => {
    if (status === "finished" || status === "skipped") {
      localStorage.setItem(hasSeenTour, "true");
      setRun(false);
    }
  };

  const restart = () => {
    localStorage.removeItem(hasSeenTour);
    setRun(true);
  };

  return { run, handleCallback, restart };
};

export default useOnboarding;